export const USER_STORAGE_KEY = 'talent.user.full'
export const USER_STORAGE_EXPIRES = 'talent.user.full.expires'

export function saveFullUser(user, expiresAt) {
  try {
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user))
    localStorage.setItem(USER_STORAGE_EXPIRES, expiresAt.toISOString())
  } catch (e) {
    console.warn('[userStorage] saveFullUser failed:', e.message)
  }
}

export function loadFullUser() {
  try {
    const expires = localStorage.getItem(USER_STORAGE_EXPIRES)
    if (!expires) return null

    if (new Date(expires).getTime() < Date.now()) {
      removeFullUser()
      return null
    }

    const user = localStorage.getItem(USER_STORAGE_KEY)
    return user ? JSON.parse(user) : null
  } catch (e) {
    console.warn('[userStorage] loadFullUser failed:', e.message)
    return null
  }
}

export function removeFullUser() {
  try {
    localStorage.removeItem(USER_STORAGE_KEY)
    localStorage.removeItem(USER_STORAGE_EXPIRES)
  } catch (e) {
    console.warn('[userStorage] removeFullUser failed:', e.message)
  }
}
